import api from "../../api";
import eventBus from '@/utils/eventBus';
 

export const MultipleServiceConfigIndex = {
    props:{     
       product: {           
          type: Object,
          default: {}
       }
    },
    model: {
        prop: 'productServicePrices',
        event: 'serviceConfigVal'
      },
    data(){
      return {
        modalVisible: false,
      modalLoading: false,
      classIndex: null,
      productIndex: null,
      selectProductService: '',
      // 一级选中的服务
      mainSelectProductService: {
        productCode: undefined,
        productName: undefined,
        productDetail: undefined,
        productClassId: undefined,
        productClassCode: undefined,
        productClassName: undefined,
        productSeriesId: undefined,
        productSeriesName: undefined,
        costPrice: undefined,
        listPrice: undefined,
        selectedYear: undefined,
        productUnit:undefined,
      },
      // 一级服务列表 mainServiceList
      mainServiceList: [],
      // 一级服务的年份
      mainServiceYearList: [],
      // 二级服务配置选项列表 
      secondaryServiceList: [],
      // 二级已选中的服务列表
      secondarySelectServiceList: [],
      formData: {},
      form: {
        firstLevelService: {
          productCode: '',
          selectedYear: 0,
        },
        firstLevelServiceSelectedYear: 0,
       },
      // 选中的服务列表
      productServicePrices: [],
      };
    },
    methods:{
          //  进行初始化  取参
    initData() { 
        this.formData.productCode = this.product.productCode;
        this.formData.price = this.product.productPrice;
        let tcount = this.product.tCount;
        if (!tcount) {
          tcount = 1;
        }
        this.formData.quantity = this.product.purchaseQuantity * tcount;
        this.formData.productNum = this.product.purchaseQuantity * tcount;
        this.formData.packageId = this.product.servicePackageId; 
        this.formData.serviceSelectedList = this.product.serviceSelectedList;
        this.getProductServiceList();  // 调用 配置服务 接口
      },
        // 点击配置服务  获取产品服务列表
    getProductServiceList() { 
        let body = {
          projectId:this.product.projectId,
          packageId: this.product.servicePackageId,
          productCode: this.product.productCode,
          productNum: this.formData.productNum,
          price: this.product.productPrice,
          serviceSelectedList:[]
        };
        api.productServiceEcho(body).then(res => { 
          let json = res.data;
          if (json.status === '200') {
            this.mainServiceList = json.data;
            
            for (let mainService of this.mainServiceList) {
              if (mainService.checked) {
                Object.assign(this.mainSelectProductService, mainService);
                this.mainServiceYearList = mainService.yearList;
                this.secondarySelectServiceList = [];
                console.log(mainService.secondaryServiceList.length);
                for (let subIndex = 0; subIndex < mainService.secondaryServiceList.length; subIndex++) {
                  this.secondarySelectServiceList.push({
                    productCode: undefined,
                    productName: undefined,
                    yearList: undefined,
                    listPrice: undefined,
                    selectedYear: undefined,
                    productDetail: undefined,
                    productUnit:undefined,
                  });
                }
                // console.log(this.secondarySelectServiceList);
                /**
                 * 循环  mainService.secondaryServiceList
                 * 找到 secondaryService 中 checked 为true的 对象 
                 * 进行合并 到 secondarySelectServiceList[subIndex]
                 *  合并到二级已选中的服务列表
                */
                for (let subIndex = 0; subIndex < mainService.secondaryServiceList.length; subIndex++) {
                  for (const secondaryService of mainService.secondaryServiceList[subIndex].serviceProductList) {
                    if (secondaryService.checked) {
                      Object.assign(this.secondarySelectServiceList[subIndex], secondaryService);
                    }
                  }
                }
                //  赋值个给 secondaryServiceList 二级服务列表
                this.secondaryServiceList = mainService.secondaryServiceList;
              }
            }
          }
          this.modalLoading = false;
        }).catch(e => {
          this.modalLoading = false;
        });
      }, 
         //  选择服务 配置 一组的 服务类型 111
    selectServiceClick(val) { 
        let row = {};
        for (const mainService of this.mainServiceList) {
          if (val === mainService.productCode) {
            row = mainService;
          }
        }
        Object.assign(this.mainSelectProductService, row);
        this.mainServiceYearList = row.yearList;
   
        for (let subIndex = 0; subIndex < row.secondaryServiceList.length; subIndex++) {
          this.secondarySelectServiceList.push({
            productCode: undefined,
            productName: undefined,
            productDetail: undefined,
            productClassId: undefined,
            productClassCode: undefined,
            productClassName: undefined,
            productSeriesId: undefined,
            productSeriesName: undefined,
            costPrice: undefined,
            listPrice: undefined,
            selectedYear: undefined,
            firstRetailPriceType: undefined,
            firstRetailPriceCoefficient: undefined,
            firstCostType: undefined,
            firstCostCoefficient: undefined,
            serviceLadderStandard: undefined,
            secondRetailPriceType: undefined,
            secondRetailPriceCoefficient: undefined,
            secondCostType: undefined,
            secondCostCoefficient: undefined
          });
        }
        for (let subIndex = 0; subIndex < row.secondaryServiceList.length; subIndex++) {
          for (const secondaryService of row.secondaryServiceList[subIndex].serviceProductList) {
            if (secondaryService.checked) {
              Object.assign(this.secondarySelectServiceList[subIndex], secondaryService);
            }
          } 
        }
        this.secondaryServiceList = row.secondaryServiceList;
      },
        // 选择 配置服一组的 服务时长 2222  
    serviceNumChange(value) { 
        this.mainSelectProductService.selectedYear = value;
        this.formData.serviceSelectedList = [{
          productCode: this.mainSelectProductService.productCode,
          selectedYear: this.mainSelectProductService.selectedYear
        }];
        // this.getServiceFee(this.formData, 1, null);
      },
       // 将选中的服务可选年份动态加载出来  服务类型  第二组 服务类型 3333 
    secondarySelectServiceClick (row, index, val) {
        for (const serviceProduct of row.serviceProductList) {
          if (serviceProduct.productCode === val.productCode) {
            Object.assign(this.secondarySelectServiceList[index], serviceProduct);
          }
        }
      },
        // 选择 第二组服务配置 时长 444
    secondaryServiceNumChange (value, index) {
        this.formData.serviceSelectedList = [
          { 
            productCode: this.secondarySelectServiceList[index].productCode, 
            selectedYear: this.secondarySelectServiceList[index].selectedYear 
          }
        ];
        // this.getServiceFee(this.formData, 2, index);
      },
       // 点击保存  使用 事件总线 回调父组件函数
    onSubmit() {
        this.productServicePrices = [];
        let main = {
          productCode: this.mainSelectProductService.productCode,
          productName: this.mainSelectProductService.productName,
          productDetail: this.mainSelectProductService.productDetail,
          productClassId: this.mainSelectProductService.productClassId,
          productClassCode: this.mainSelectProductService.productClassCode,
          productClassName: this.mainSelectProductService.productClassName,
          productSeriesId: this.mainSelectProductService.productSeriesId,
          productSeriesName: this.mainSelectProductService.productSeriesName,
          costPrice: this.mainSelectProductService.costPrice,
          listPrice: this.mainSelectProductService.listPrice,
          selectedYear: this.mainSelectProductService.selectedYear,
          firstRetailPriceType: this.mainSelectProductService.firstRetailPriceType,
          firstRetailPriceCoefficient: this.mainSelectProductService.firstRetailPriceCoefficient,
          firstCostType: this.mainSelectProductService.firstCostType,
          firstCostCoefficient: this.mainSelectProductService.firstCostCoefficient,
          serviceLadderStandard: this.mainSelectProductService.serviceLadderStandard,
          secondRetailPriceType: this.mainSelectProductService.secondRetailPriceType,
          secondRetailPriceCoefficient: this.mainSelectProductService.secondRetailPriceCoefficient,
          secondCostType: this.mainSelectProductService.secondCostType,
          secondCostCoefficient: this.mainSelectProductService.secondCostCoefficient,
          productUnit:this.mainSelectProductService.productUnit
        };
        this.productServicePrices.push(main);
        for (let secondaryServiceElement of this.secondarySelectServiceList) {
          let second = {
            productCode: secondaryServiceElement.productCode,
            productName: secondaryServiceElement.productName,
            productDetail: secondaryServiceElement.productDetail,
            productClassId: secondaryServiceElement.productClassId,
            productClassCode: secondaryServiceElement.productClassCode,
            productClassName: secondaryServiceElement.productClassName,
            productSeriesId: secondaryServiceElement.productSeriesId,
            productSeriesName: secondaryServiceElement.productSeriesName,
            costPrice: secondaryServiceElement.costPrice,
            listPrice: secondaryServiceElement.listPrice,
            selectedYear: secondaryServiceElement.selectedYear,
            firstRetailPriceType: secondaryServiceElement.firstRetailPriceType,
            firstRetailPriceCoefficient: secondaryServiceElement.firstRetailPriceCoefficient,
            firstCostType: secondaryServiceElement.firstCostType,
            firstCostCoefficient: secondaryServiceElement.firstCostCoefficient,
            serviceLadderStandard: secondaryServiceElement.serviceLadderStandard,
            secondRetailPriceType: secondaryServiceElement.secondRetailPriceType,
            secondRetailPriceCoefficient: secondaryServiceElement.secondRetailPriceCoefficient,
            secondCostType: secondaryServiceElement.secondCostType,
            secondCostCoefficient: secondaryServiceElement.secondCostCoefficient
          };
          if (second.productCode) {
            this.productServicePrices.push(second);
          }
        }
        
      // 事件总线 传值到 父组件  批量修改配置服务  将已选的配置服务传给 父组件
        eventBus.$emit('batchSaveServiceList', this.productServicePrices);
      },  
    // 关闭 选择配置服务  事件总线 传递父组件 
    cancel() {
        eventBus.$emit('isShowMultipleServiceConfig', false);
      },
    },
    mounted() { 
        this.initData();  // 页面加载完毕 调用
        console.log('批量修改.product', this.product);
    }
};
